import React, { useEffect } from "react";
import { usePlaidLink } from "react-plaid-link";

interface PlaidBankLinkProps {
  token: string;
  onLinked: (publicToken: string, accountIds: string[]) => void;
  onExit: () => void;
}

// Opens Plaid Link as soon as the token is ready; the parent owns everything shown around it
const PlaidBankLink: React.FC<PlaidBankLinkProps> = ({
  token,
  onLinked,
  onExit,
}) => {
  const { open, ready } = usePlaidLink({
    token,
    onSuccess: (publicToken, metadata) => {
      onLinked(
        publicToken,
        (metadata.accounts ?? []).map((account) => account.id),
      );
    },
    onExit: () => onExit(),
  });

  useEffect(() => {
    if (ready) open();
  }, [ready, open]);

  return null;
};

export default PlaidBankLink;
